export const textAlignClass = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};
